import {analysisCategories} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {
  UseDistinctListProps,
  DistinctValuesResponse,
  DistinctValue,
  AutocompleteOption
} from '@hconnect/common/maintain-filters'
import {useQuery} from '@tanstack/react-query'

export const QueryKey = 'distinct-analysis-vals'

export const useDistinctCategoryListValues = ({
  id,
  apiUrl,
  filters,
  apiParams
}: UseDistinctListProps) => {
  return useQuery({
    queryKey: [QueryKey, id, apiUrl, filters, apiParams],
    queryFn: async () => {
      return (
        await ApiClient.axiosInstance.post<DistinctValuesResponse>(
          apiUrl,
          {pageSize: null, pageNumber: 0, property: id, filters: filters, ...apiParams},
          {}
        )
      ).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,
    select: (data) => generateCategoryOptions(data.data)
  })
}

const generateCategoryOptions = (data: DistinctValue[]) => {
  const autocompleteOptions: AutocompleteOption[] = []
  const processedValues = new Set<string>()

  data.forEach((option) => {
    const id = option.value
    const value =
      analysisCategories.find((c) => c.id.toLowerCase() === option.value.toLowerCase())?.label ??
      null
    if (!value) return
    if (processedValues.has(value)) return
    processedValues.add(value)

    autocompleteOptions.push({
      id: id,
      label: value
    })
  })

  return autocompleteOptions
}
